import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const InvoiceTypeForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'workflow'

    const linkedItem = { connected_feature: 'invoice' }

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'workflow.general.name_label',
            type: 'text',
            placeholder: 'invoice.invoice_type.general.name_placeholder',
            width: '50%',
            group: 'field-row-1',
        },
        { 
            type: 'dropdown', 
            name: 'connected_feature', 
            label: 'workflow.general.connected_feature_label', 
            disabled_selected: 'forms.select_type_disabled_selected',
            dependentOn: { fieldName: '', value: [''] }, // Hacky solution to hide field in the form
            defaultValue: { value: 'invoice'},
            allowNoneOption: false,
            showSearch: false,
            width: '50%',
            group: 'field-row-2',
            hardcodedOptions: ([
                { value: 'invoice', name: 'workflow.connected_feature.invoice', requiredFeature: 'invoices' },
            ]),
        },
        {
            name: 'is_default',
            label: 'workflow.general.is_default_label',
            type: 'checkbox',
            width: '50%',
            group: 'field-row-3',
        },

        // Invoice workflow details
        {
            type: 'divider',
        },
        {
            type: 'header',
            header: 'workflow.general.invoice_settings_header',
        },
        {
            name: 'invoice_expiration_days',
            type: 'expiration-days',
            featureName: 'invoice',
            placeholder: 'workflow.general.expiration_placeholder',
            group: 'field-row-4',
            width: '50%',
        },
        {
            name: 'invoice_default_vat_method',
            type: 'dropdown',
            label: 'workflow.general.vat_method_label',
            tooltipText: 'workflow.general.invoice_vat_method_tooltipText',
            hardcodedOptions: [
                { name: 'document_lines.general.vat_excluded_label', value: 'vat_excluded' },
                { name: 'document_lines.general.vat_included_label', value: 'vat_included' },
            ],
            defaultValue: { value: 'vat_excluded' },
            allowNoneOption: false,
            showSearch: false,
            group: 'field-row-5',
            width: '33%',
        },
        {
            name: 'invoice_default_price_display_mode',
            type: 'dropdown',
            label: 'workflow.general.price_display_mode_label',
            tooltipText: 'workflow.general.invoice_price_display_mode_tooltipText',
            hardcodedOptions: [
                { name: 'document_lines.price_display_mode.line_prices', value: 'line_prices' },
                { name: 'document_lines.price_display_mode.total_price', value: 'total_price' },
            ],
            defaultValue: { value: 'line_prices' },
            allowNoneOption: false,
            showSearch: false,
            group: 'field-row-6',
            width: '33%',
        },
        {
            name: 'invoice_type',
            type: 'dropdown',
            label: 'workflow.general.invoice_type_label',
            hardcodedOptions: [
                { name: 'workflow.general.invoice_type_invoice', value: 'invoice' },
                { name: 'workflow.general.invoice_type_proforma', value: 'proforma' },
            ],
            defaultValue: { value: 'invoice' },
            allowNoneOption: false,
            showSearch: false,
            group: 'field-row-invoice-type',
            width: '33%',
        },
        {
            type: 'header',
            header: 'workflow.general.invoice_is_partial_header',
            description: 'workflow.general.invoice_is_partial_description',
        },
        {
            name: 'is_partial_invoice',
            label: 'workflow.general.invoice_is_partial_label',
            type: 'checkbox',
            align: 'left',
            group: 'field-row-7',
            width: '50%',
        },
        {
            name: 'partial_percentage',
            label: 'workflow.general.invoice_partial_percentage_label',
            type: 'percentage',
            width: '20%',
            dependentOn: { fieldName: 'is_partial_invoice', value: true },
        },
        {
            type: 'header',
            header: 'workflow.general.default_invoice_line_text_label',
            description: 'workflow.general.default_invoice_line_text_description',
        },
        {
            name: 'use_default_invoice_line',
            label: 'workflow.general.use_default_invoice_line_label',
            type: 'checkbox',
            align: 'left',
            width: '50%',
            group: 'field-row-8',
        },
        {
            name: 'default_invoice_line_text',
            type: 'textarea',
            placeholder: 'workflow.general.default_invoice_line_text_placeholder',
            rows: 2,
            enableStyling: 'simple',
            showToolbarInitially: true,
            dependentOn: { fieldName: 'use_default_invoice_line', value: true },
        },
        {
            type: 'header',
            header: 'workflow.general.default_invoice_conditions_header',
            description: 'workflow.general.default_invoice_conditions_description',
        },
        {
            type: 'condition-lines-defaults',
            name: 'default_invoice_condition_lines',
        },
        {
            name: 'default_invoice_conditions',
            type: 'textarea',
            placeholder: 'workflow.general.default_invoice_conditions_placeholder',
            rows: 3,
            enableStyling: 'simple',
            showToolbarInitially: true,
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
        />
    );
};

export default InvoiceTypeForm;